export class MobileMenu {
    private menu: HTMLElement;
    private button: HTMLDivElement;
    private uspModule: HTMLElement;
    private headModule: HTMLElement;
    private isNavOpen: boolean;
    private searchButton: HTMLAnchorElement;
    private lastScrollPosition: number = 0; // Variable zum Speichern der Scrollposition

    constructor() {
        this.button = document.querySelector('.clx-nav-open') as HTMLDivElement;
        this.searchButton = document.querySelector('.hf_search-trigger') as HTMLAnchorElement;

        this.menu = document.querySelector('.hf_main_nav') as HTMLElement;
        this.uspModule = document.querySelector('.cms-module-usp') as HTMLElement;
        this.headModule = document.querySelector('.cms-module-head') as HTMLElement;
        this.isNavOpen = false;

        this.initEvents();
    }

    private initEvents(): void {
        // Toggle the menu
        if (this.button) {
            this.button.addEventListener('click', () => {
                this.toggleMenu();
            });
        }

        // Search button closes menu when open
        if (this.searchButton) {
            this.searchButton.addEventListener('click', () => {
                if (this.isNavOpen) {
                    this.toggleMenu();
                }
            });
        }
    }

    private toggleMenu(): void {
        if (this.isNavOpen) {
            this.closeMenu();
        } else {
            this.openMenu();
            this.lazyLoadImagesInNav();
        }

        document.documentElement.classList.toggle('no-scroll');
        document.body.classList.toggle('no-scroll');
        this.button.classList.toggle('open');
        this.menu.classList.toggle('active');
        this.isNavOpen = !this.isNavOpen;
    }

    private openMenu(): void {
        this.lastScrollPosition = window.scrollY;

        const height = this.uspModule.clientHeight + this.headModule.clientHeight;
        const heightMinusHead = window.innerHeight - height;
        this.menu.style.position = 'relative';
        this.menu.style.height = `${heightMinusHead}px`;
        this.menu.style.visibility = 'visible';
        this.uspModule.style.opacity = '0';

        this.scrollToTop();
    }

    private closeMenu(): void {
        this.menu.style.position = '';
        this.menu.style.height = '';
        this.menu.style.visibility = 'hidden';
        this.uspModule.style.opacity = '1';

        setTimeout(() => {
            this.restoreScrollPosition();
        }, 100);
    }

    private scrollToTop(): void {
        window.scrollTo({
            top: 0,
        });
    }

    private restoreScrollPosition(): void {
        window.scrollTo({
            top: this.lastScrollPosition,
        });
    }

    private lazyLoadImagesInNav = (): void => {
        const header = document.querySelector('header#header') as HTMLElement;
        if (!header) return;

        const images = header.querySelectorAll('img[data-src]') as NodeListOf<HTMLImageElement>;
        images.forEach((img) => {
            if (img && !img.src) {
                const dataSrc = img.getAttribute('data-src');
                if (dataSrc) {
                    img.src = dataSrc;
                    img.removeAttribute('data-src');
                }
            }
        });
    };
}
